'use strict';

/**
 * Sets the cookie with expiration
 * @param key - cookie name
 * @param value - cookie value
 * @param days - cookie expiration in days
 */
 function setCookie(key, value, days) {
    if (!key || !value) return;

    var date = new Date();

    // Default at 365 days.
    days = days || 365;

    // Get unix milliseconds at current time plus number of days
    date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000

    window.document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';

    return value;
}

/**
 * Get Cookie
 * @param {String} cname - cookie name
 * @returns {void}
 */
function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');

    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

/**
 * Delete Cookie
 * @param {String} cname - cookie name
 * @returns {void}
 */
function deleteCookie(cname) {
    window.document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

module.exports = {
    setCookie: setCookie,
    getCookie: getCookie,
    deleteCookie: deleteCookie,
}
